import React, { useState, useCallback, useEffect, useRef } from "react";
import { useLocalStorageState } from "ahooks";
import { useHistory } from "react-router-dom";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import { NavLink } from "../../lib/Navigation";
import { useScroll } from "ahooks";
import FreeEdition from "../components/FreeEdition";
import GameInfo from "../components/Home/GameInfo";
import $ from "jquery";
import "./css/Search.css";
import Manager from "../components/Manager";

// 渲染高亮文本的辅助函数
const renderHighlight = (text, highlight) => {
  if (!text) return null;
  const cleanHighlight = (highlight || "").trim();
  if (!cleanHighlight) return text;

  try {
    const escapedHighlight = cleanHighlight.replace(
      /[-\/\\^$*+?.()|[\]{}]/g,
      "\\$&",
    );
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === cleanHighlight.toLowerCase() ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        <span key={index}>{part}</span>
      ),
    );
  } catch {
    return text;
  }
};

export default function Search(props) {
  const [isSearching, setIsSearching] = useState(false);
  const [searchHistory, setSearchHistory] = useLocalStorageState(
    "trade_search_history",
    [],
  );
  const history = useHistory();
  const [init, setInit] = useState(false);
  const [searchInit, setSearchInit] = useState(false);
  const [kw, setKw] = useState("");
  const isOnComposition = useRef(false);

  const [play_game_list, setPlayGameList] = useState([]);
  const [recommend_game_list, setRecommendGameList] = useState([]);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [more, setMore] = useState(false);

  const load = () => {
    if (!init) {
      Dialog.loading();
    }
    general.axios
      .post("/tradeSeekIndex")
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setInit(true);
        setPlayGameList(data.play_game_list || []);
        setRecommendGameList(data.recommend_game_list || []);
      });
  };

  // 1. 声明一个真实的 ref 对象来保存输入框 DOM 实例，供后续读取
  const actualInputRef = useRef(null);

  // 2. 将其组合进您的回调 Ref 中
  const inputRef = useCallback((node) => {
    // 将真实 DOM 保存起来
    actualInputRef.current = node;

    if (node) {
      node.addEventListener(
        "input",
        (e) => {
          if (
            e.inputType === "insertText" ||
            e.inputType === "deleteContentBackward" ||
            e.inputType === "insertFromPaste"
          ) {
            setKw(e.target.value);
          }
        },
        { passive: false },
      );
    }
  }, []);

  const handleComposition = (e) => {
    isOnComposition.current = e.type !== "compositionend";
    if (!isOnComposition.current) {
      setKw(e.target.value);
    }
  };

  const saveHistory = (word) => {
    if (!word.trim()) return;
    const filtered = (searchHistory || []).filter(
      (item) => item !== word.trim(),
    );
    setSearchHistory([word.trim(), ...filtered].slice(0, 20));
  };

  const clearHistory = () => {
    setSearchHistory([]);
  };

  const searchGame = (params) => {
    if (loading) {
      return;
    }
    setSearchInit(false); // Set searchInit to true when a search is initiated
    setLoading(true);
    const nextPage = params.page;
    general.axios
      .post("/searchTradeGame", {
        search_info: kw.trim(),
        pagination: {
          page: nextPage,
          page_size: 20,
        },
      })
      .finally(() => {
        setLoading(false);
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        const newList = data.list || [];
        if (nextPage === 1) {
          setList(newList);
        } else {
          setList((prevList) => [...prevList, ...newList]);
        }
        setMore(data.paginated.more);
        setPage(nextPage);
        setSearchInit(true); // Set searchInit to true after the first search
      });
  };

  useEffect(() => {
    if (kw.trim() === "") {
      return;
    }
    const trimmedKw = kw.trim();
    setIsSearching(trimmedKw !== "");
    searchGame({ page: 1 });
  }, [kw]);

  useEffect(() => {
    if (props.active) {
      load();
      props.setTitle(
        <div className="search-index-input">
          <img src="/resources/user/ss.png" className="icon" />
          <input
            type="text"
            placeholder="请输入游戏名称"
            onCompositionStart={handleComposition}
            onCompositionUpdate={handleComposition}
            onCompositionEnd={handleComposition}
            onChange={(e) => {
              if (!isOnComposition.current) {
                setKw(e.target.value);
              }
              setIsSearching(e.target.value.trim() !== "");
            }}
            ref={inputRef}
          />
        </div>,
      );
      props.setOperate(
        <div
          style={{ fontSize: "0.28rem", color: "var(--MainColor)" }}
          onClick={() => {}}
        >
          搜索
        </div>,
      );
    }
  }, [props.active]); // Added kw and inputRef dependencies

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        searchGame({ page: 1 });
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        searchGame({ page: page + 1 });
      }
    }
  }, [scroll, init, props.active]);

  return (
    <div className="trade-search-component">
      <div className="search-content">
        {isSearching ? (
          <div className="search-results">
            {list.map((game) => (
              <NavLink
                user={false}
                to={`/detailTrade?id=${game.game_id}`}
                key={game.game_id}
                className="result-item"
                onClick={(e) => {
                  saveHistory(game.game_name);
                  if (parseInt(game.trade_count) === 0) {
                    Dialog.info("该游戏暂无小号出售");
                    e.preventDefault(); // Prevent navigation if there are no trades
                  }
                }} // Save current keyword on click
              >
                <div className="game-img-placeholder">
                  <img src={game.game_image.thumb} alt={game.game_name} />
                </div>
                <div className="game-info">
                  <div className="game-name">
                    {renderHighlight(game.game_name, kw)}
                  </div>
                  <div className="game-desc">
                    {game.versionCode.trim()} · 有
                    <span className="highlight">{game.trade_count}</span>
                    个小号出售
                  </div>
                </div>
              </NavLink>
            ))}
            {list.length > 10 && !more && searchInit && (
              <div className="view-end">别撩啦！已经到底啦~</div>
            )}
            {list.length == 0 && searchInit && (
              <div className="empty">
                <img src="/resources/empty.png" alt="" />
                暂无数据
              </div>
            )}
          </div>
        ) : (
          <div className="default-state">
            {searchHistory.length > 0 && (
              <div className="section">
                <div className="section-header">
                  <h3>搜索历史</h3>
                  <div className="clear-history" onClick={clearHistory}>
                    <img
                      src="/resources/search/history_unset.png"
                      alt="Clear history"
                      height={16}
                    />
                  </div>
                </div>
                <div className="history-tags">
                  {searchHistory.map((word) => (
                    <div
                      key={word}
                      className="history-tag"
                      onClick={() => {
                        setKw(word);
                        console.log(
                          "Setting input value to:",
                          word,
                          actualInputRef.current,
                        );
                        if (actualInputRef.current) {
                          actualInputRef.current.value = word; // 直接操作保存的真实 DOM
                        }
                      }}
                    >
                      <span>{word}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {play_game_list.length > 0 && (
              <div className="section">
                <h3>我玩过的</h3>
                <div className="game-grid">
                  {play_game_list.map((game) => (
                    <NavLink
                      onClick={() => {
                        Manager.push({ event_id: 'A-4-18' });
                      }}
                      to={`/detailTrade?id=${game.game_id}`}
                      key={game.game_id}
                      className="game-item"
                    >
                      <div className="game-img-placeholder">
                        <img src={game.game_icon} alt="" height={68} />
                      </div>
                      <p>{game.game_name}</p>
                    </NavLink>
                  ))}
                </div>
              </div>
            )}
            {recommend_game_list.length > 0 && (
              <div className="section">
                <h3>热门游戏推荐</h3>
                <div className="recommend-game-list">
                  {recommend_game_list.map((game,index) => (
                    <NavLink
                      onClick={() => {
                        Manager.push({ event_id: 'A-4-19' });
                      }}
                      user={false}
                      to={`/detailTrade?id=${game.game_id}`}
                      key={game.game_id}
                      className="game-item"
                    >
                      <div className="game-img-placeholder">
                        <img src={game.game_icon} alt="" />
                        {index < 3 && <div className="index"><img src={`/resources/index/new-${index + 1}.png`} alt="" height={24}/></div>}
                      </div>
                      <div className="game-info">
                        <div className="game-name">{game.game_name}</div>
                        <GameInfo>{game}</GameInfo>
                        <div className="desc">
                          该游戏有
                          <span className="trade-count">
                            {game?.trade_count}
                          </span>
                          个小号出售
                        </div>
                      </div>
                      <FreeEdition>{game}</FreeEdition>
                    </NavLink>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
